import { useNavigate } from "react-router-dom";
import { useAuth } from "./core/auth/contexts/AuthContext";
import Layout from "./shared/components/layout/Layout";
import { Toaster } from "@/components/ui/sonner";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./app/store";
import { useEffect } from "react";

function App()  {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    console.log('auth user',auth);
    
    if (!auth.user) {
      navigate("/sign-in", { replace: true });
    }
  }, [auth, navigate]);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Toaster
          position="top-right"
          richColors
          closeButton
          toastOptions={{
            unstyled: false,
            classNames: {
              error: "bg-red-400",
              success: "text-green-400",
              warning: "text-yellow-400",
              info: "bg-blue-400",
            },
          }}
        />
        <Layout />
      </PersistGate>
    </Provider>
  );
}

export default App;
